import { FC } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    label: {
        color: 'var(--ion-color-step-750)'
    }
});

// Marks a note added from a family's texted reply.
export const ViaTextLabel: FC = () => {
    const classes = useStyles();
    return <span className={classes.label} data-id="via-text-label">via text</span>;
};
